import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { DeviceIncidentRule, IncidentRuleBase } from '@devices/models';
import { firstValueFrom, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IncidentRulesService {
  private http = inject(HttpClient);

  getIncidentRules(deviceId: string, params: Record<string, string | boolean | number> = {}): Observable<DeviceIncidentRule[]> {
    return this.http.get<{ count: number; data: DeviceIncidentRule[]; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/incident-rules`,
      { params },
    )
      .pipe(map(response => response.data));
  }

  createIncidentRule(deviceId: string, body: IncidentRuleBase): Observable<DeviceIncidentRule> {
    return this.http.post<{ data: DeviceIncidentRule; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/incident-rules`,
      body,
    )
      .pipe(map(response => response.data));
  }

  updateIncidentRule({ deviceId, body, incidentRuleId }: { body: Partial<DeviceIncidentRule>; deviceId: string; incidentRuleId: string; }): Observable<DeviceIncidentRule> {
    return this.http.put<{ data: DeviceIncidentRule; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/incident-rules/${incidentRuleId}`,
      body,
    )
      .pipe(map(response => response.data));
  }

  deleteIncidentRule(deviceId: string, workflowId: string): Observable<unknown> {
    return this.http.delete(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/incident-rules/${workflowId}`,
    );
  }

  shareIncidentRule(sourceDeviceId: string, incidentRuleId: string, { replaceExisting, targetDeviceIds }:
    { replaceExisting: boolean; targetDeviceIds: string[] }): Observable<unknown> {
    return this.http.post(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${sourceDeviceId}/incident-rules/${incidentRuleId}/populate-similar`,
      { replaceExisting, targetDeviceIds },
    );
  }
}
